import { render, staticRenderFns } from "./PrintTicketView.vue?vue&type=template&id=260e867f"
import script from "./PrintTicketView.vue?vue&type=script&lang=js"
export * from "./PrintTicketView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports